import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../../state/reducers';
import { IProps, IStateProps } from './interfaces';
import {
  Container,
  Placeholder,
} from './styles';

const ExchangeEmptyMedia: React.FC<IProps> = (props: IProps) => (
  <Container>
    <Placeholder data-tip="Video Unavailable">
      {props.message}
    </Placeholder>
  </Container>
);

const mapStateToProps = (state: IAppState): IStateProps => ({
  message: state.exchange?.activeAsset?.mediaInformation?.message ?? '',
});

export default connect(
  mapStateToProps,
)(ExchangeEmptyMedia);
